"use client"

import {useEffect, useState} from 'react';
import {Prayers} from "@/types/Prayers";
import {useAppStore} from "@/store/AppStore";
import {spiritualityRequest} from "@/utils/api/Spirituality";
import {useLocale} from "use-intl";

const useSpiritualityData = (token?: string) => {
  const locale = useLocale()
  const [data, setData] = useState<Prayers | undefined>(undefined)
  const setRefresh = useAppStore((state) => state.setRefresh);

  useEffect(() => {
    const fetchData = async (token: string) => {
      const fetched = await spiritualityRequest(token, locale)
      if (false === fetched) {
        setRefresh(true)
        return true
      }
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data && token) {
      fetchData(token)
    }
  }, [setRefresh, token, data, locale]);

  return data
};

export default useSpiritualityData;
